// Global imports
window.$ = window.jQuery = require('jquery') // Necessary for client/lib/request
// Vendor imports
const ReactDOM = require('react-dom')
// Client V2 imports
const { applyReportedArticlesCache } = require('client-v2/common/models/article/actions')
const hydrateStore = require('client-v2/common/state/hydrate')
const { configureHistory } = require('client-v2/common/state/router/actions')
const { createHistory } = require('client-v2/common/state/router/history')

exports.render = function (configureStore, rootFactory) {
  // Create a namespace for app-related references
  const app = window.app = {}

  // Re-initialize the Redux store from serialized state
  const store = app.store = hydrateStore(configureStore)

  // Hook the history management up to the Redux store
  const history = app.history = createHistory(store)
  store.dispatch(configureHistory(history))

  // Redirect proxied/archived pages to the real server.
  ensureCanonicalDomain(store)

  // Setup libraries that depend on env/user state
  configureAirbrake(store)
  app.session = configureSession(store)

  // Prepare the root DOM element and root React component
  const rootElement = document.getElementById('root')
  const rootComponent = rootFactory(app)

  // Adopt the server-side rendered React Components (if available)
  if (rootElement.hasChildNodes()) {
    ReactDOM.hydrate(rootComponent, rootElement)
  } else {
    ReactDOM.render(rootComponent, rootElement)
  }

  // Reject reported URLs that have been locally cached
  // This has to come after hydration to prevent mismatching
  store.dispatch(applyReportedArticlesCache())

  return app
}

function ensureCanonicalDomain(store) {
  // Allow non-canonical domains during local development
  if (__DEV__) {
    return
  }
  // Prevent proxies from displaying the site on their domains
  const { env: { baseUrl } } = store.getState()
  const { href, pathname, search } = window.location
  if (baseUrl && !href.startsWith(baseUrl)) {
    const canonicalHref = baseUrl + pathname + search
    window.location.assign(canonicalHref)
  }
}

function configureAirbrake(store) {
  // Client lib imports
  const airbrake = require('client/lib/airbrake')

  const { env } = store.getState()
  airbrake.configure()
  airbrake.attachBuildNumber(env.buildNumber)
  airbrake.addFilter(notice => {
    // Attach Redux store state to notices
    let state = store.getState()
    if (typeof state.toJS === 'function') {
      // Convert Record to JSON
      state = state.toJS()
    }
    notice.session = state
    return notice
  })
}

function configureSession(store) {
  // Client lib imports
  const businessEvents = require('client/lib/business-events')
  const Request = require('client/lib/request')
  const Session = require('client/lib/sess')

  // Setup user session ID and V1 library helper functions
  const state = store.getState()
  const { buildNumber, csrfToken } = state.env
  // Convert UserRecord to a plain Object for compatibility with wiggin
  const user = state.user.toJS()
  const session = new Session(user)
  const getSessionId = () => session.update()
  const getPageName = pageContext => {
    if (pageContext && pageContext['page_name']) {
      return pageContext['page_name']
    }
    return store.getState().router.action
  }
  const onCsrfError = () => window.location.reload()

  // Configure V1 libraries to work without wiggin
  Request.configure({
    buildNumber,
    csrfToken,
    getPageName,
    getSessionId,
    onCsrfError
  })
  businessEvents.configure({
    buildNumber,
    getPageName,
    getSessionId,
    user
  })
  businessEvents.identifyUser(user)

  // Ensure that the initial session ID cookie is set
  // This needs to happen *after* configuring Request and businessEvents
  session.update()
  return session
}
